import {PayloadAction} from "@reduxjs/toolkit";
import {call, put} from "redux-saga/effects";
import {api} from "../../api/api";
import {ApiError} from "../../api/sendRequest";
import {SessionDto} from "../auth.interface";
import {authActions} from "../auth.slice";

export function* signInWithGoogleSaga(action: PayloadAction<string>) {
    try {
        const session = (yield call(api.googleLogin, action.payload)) as SessionDto;
        yield put(authActions.setSession(session.email));
    } catch (error) {
        const denied = (error as ApiError).status === 403;
        yield put(authActions.setSignInError(denied ? 'denied' : 'failed'));
    }
}
